import { createFileRoute } from "@tanstack/react-router";
import { Container } from "@/components/admin/Container";
import { Header } from "@/components/admin/Header";
import { Searchbar } from "@/components/admin/Searchbar";
import { Separator } from "@/components/ui/separator";
import { MetricsChart } from "@/modules/dashboard/metrics-chart";
import { NewPatients } from "@/modules/dashboard/new-patients";
import { OverviewChart } from "@/modules/dashboard/overview-chart";
import { PreviousMonthComparationChart } from "@/modules/dashboard/previous-month-comparation-chart";

export const Route = createFileRoute("/dashboard/")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<>
			<Header>
				<div className="ml-auto flex items-center space-x-4">
					<Searchbar />
				</div>
			</Header>

			<Container className="space-y-4">
				<MetricsChart />

				<Separator />

				<div className="grid grid-cols-1 gap-4 lg:grid-cols-8">
					<div className="lg:col-span-3">
						<NewPatients />
					</div>

					<div className="lg:col-span-5">
						<OverviewChart />
					</div>
				</div>

				<PreviousMonthComparationChart />
			</Container>
		</>
	);
}
